import { 
  getNotifTypes,
  getInvoicesTypes,
  getRequestedInvoicesTypes,
  electronicInvoicesTypes,
  getAssociatedInvoicesTypes,
  getUnassociatedInvoices,
  getAccountInvoicesTypes,
  getReceiptDocumentTypes,
  deleteInvoicesTypes,
} from './types';
import { loginTypes, impersonateTypes } from '../auth/types';
import { getDiffFromTodayInDays, NOTIFICATION_DAYS } from '../../helpers';

const initialState = {
  errorMessage: null,
  isLoading: false,
  isReceiptLoading: false,
  invoices: null,
  associatedInvoices: null,
  accountInvoices: null,
  requestedInvoices: null,
  unassociatedInvoices: [],
};

const invoiceReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case loginTypes.LOGOUT_SUCCESS: {
      return {
        ...initialState
      };
    }
    case impersonateTypes.ROLLBACK_SUCCESS: {
      return{
        ...initialState
      }
    }
    
    case getInvoicesTypes.REQUEST: {
      return {
        ...state,
        errorMessage: null,
        invoices: [],
        isLoading: true
      };
    }
    
    case getInvoicesTypes.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        invoices: payload.invoices
      };
    }
    
    case getInvoicesTypes.FAILED: {
      return {
        ...state,
        isLoading: false,
        errorMessage: payload
      };
    }

    case getAssociatedInvoicesTypes.REQUEST: {
      return {
        ...state,
        errorMessage: null,
        associatedInvoices: [],
        isLoading: true
      };
    }
    
    case getAssociatedInvoicesTypes.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        associatedInvoices: payload.associatedInvoices
      };
    }
    
    case getAssociatedInvoicesTypes.FAILED: {
      return {
        ...state,
        isLoading: false,
        errorMessage: payload
      };
    }

    case getUnassociatedInvoices.REQUEST: {
      return {
        ...state,
        errorMessage: null,
        unassociatedInvoices: [],
        isLoading: true
      };
    }
    
    case getUnassociatedInvoices.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        unassociatedInvoices: payload.unassociatedInvoices
      };
    }
    
    case getUnassociatedInvoices.FAILED: {
      return {
        ...state,
        isLoading: false,
        errorMessage: payload
      };
    }

    case getRequestedInvoicesTypes.REQUEST: {
      return {
        ...state,
        errorMessage: null,
        isLoading: true
      };
    }
    
    case getRequestedInvoicesTypes.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        requestedInvoices: payload.requestedInvoices
      };
    }
    
    case getRequestedInvoicesTypes.FAILED: {
      return {
        ...state,
        isLoading: false,
        errorMessage: payload
      };
    }

    case getAccountInvoicesTypes.REQUEST: {
      return {
        ...state,
        errorMessage: null,
        accountInvoices: [],
        isLoading: true
      };
    }

    case getAccountInvoicesTypes.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        accountInvoices: payload.accountInvoices
      };
    }
    
    case getAccountInvoicesTypes.FAILED: {
      return {
        ...state,
        isLoading: false,
        errorMessage: payload
      };
    }

    case electronicInvoicesTypes.DELETE_E_REQUEST: {
      return {
        ...state,
        invoices: state.invoices.filter(invoice => !payload.includes(invoice)),
      };
    }

    case getNotifTypes.REQUEST: {
      return {
        ...state,
        errorMessage: null,
        notifications: [],
        isLoading: true
      };
    }

    case getNotifTypes.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        notifications: payload.requestedNotifications.filter(
          requestedNotification => getDiffFromTodayInDays(requestedNotification.date) <= NOTIFICATION_DAYS
        ),
        notificationsNew: payload.requestedNotifications.filter(
          requestedNotification => getDiffFromTodayInDays(requestedNotification.date) <= NOTIFICATION_DAYS && !requestedNotification.isRead
        ),
      };
    }

    case getReceiptDocumentTypes.REQUEST: {
      return {
        ...state,
        isReceiptLoading: true
      };
    }
    
    case getReceiptDocumentTypes.FINISH: {
      return {
        ...state,
        isReceiptLoading: false
      };
    }
    
    case deleteInvoicesTypes.DELETE_REQUEST: {
      return {
        ...state,
        errorMessage: null,
        isLoading: true
      };
    }

    case deleteInvoicesTypes.DELETE_SUCCESS: {
      return {
        ...state,
        isLoading: false
      };
    }

    case deleteInvoicesTypes.DELETE_FAILED: {
      return {
        ...state,
        errorMessage: payload,
        isLoading: false
      };
    }

    default:
      return state;
  }
};

export default invoiceReducer;